module.exports = __webpack_public_path__ + "img/avatar6.b81226e9.png";